import { makeVar } from '@apollo/client';

import { TJobTableData } from './types';

export const isDetailsModalOpen = makeVar<boolean>(false);
export const detailsModalData = makeVar<TJobTableData | null>(null);
